<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <navBar :tags="tags" :title="title" :subTitle="subTitle" :btnSave="false" :btnBack="true"
                @btnBackClick="handleBackClick"
        />


        <el-row :gutter="20">
            <el-col :span="16">

                <div :class="$style.left">
                    <span>巡店人员</span>
                    <span>{{last_name}}</span>
                </div>
                <div :class="$style.left">
                    <span>巡店时间</span>
                    <span>{{time}}</span>
                </div>
                <div :class="$style.left">
                    <span>巡店模板</span>
                    <span>{{templateName}}</span>
                </div>

            </el-col>
            <el-col :span="8">
                <img :src="imgUrl" width="80px" style="float: right;margin-top: 20px;margin-right: 30px" v-show="seal"/>
            </el-col>
        </el-row>

        <section :class="$style.item">
            <div :class="$style.map" id="mapContainer">
                <el-amap class="amap-box" :vid="'amap-vue'" :center="center" :zoom="zoom" :plugin="plugin">
                    <el-amap-marker v-for="(marker, index) in markers" :position="marker.position"
                                    :visible="marker.visible" :key="index" :events="marker.events">
                    </el-amap-marker>
                    <el-amap-text v-for="(text, index) in texts" :text="text.name" :key="index"
                                  :offset="text.offset" :position="text.position" >
                    </el-amap-text>
                </el-amap>
            </div>
        </section>


        <el-row :gutter="24" :class="$style.row">
            <el-col :span="20"><span style="font-size: 12px;color: #B8B8B8">检查事项</span></el-col>

            <el-col :span="4"><span style="float: right;font-size: 12px;color: #FF9901">总分：{{checkAll}}</span></el-col>
        </el-row>

        <div v-for="(item, index) in checkArray">
            <div @click.stop="clickItems(item,index)" style="cursor:pointer">
                <el-row :gutter="24" :class="$style.row_child">
                    <el-col :span="12"><span
                            style="font-size: 14px;color: #4D4D4D">{{item.value1}}（{{item.count}}个项目）</span></el-col>

                    <el-col :span="12">
                        <div style="float: right;font-size: 14px">
                            <span style="color: #86909A">未检查</span>
                            <span :class="$style.span_round" style="background: #86909A">{{item.unchecked}}</span>
                            <span style="color: #6BC235">已合格</span>
                            <span :class="$style.span_round" style="background: #6BC235">{{item.pass}}</span>
                            <span style="color: #D0011B">不合格</span>
                            <span :class="$style.span_round" style="background: #D0011B">{{item.not_pass}}</span>
                            <span style="color: #B0B5B9;margin-right: 5px;margin-left: 5px">|</span>
                            <span>{{item.score}}分</span>

                            <img :src="arrow" height="12px" style="margin-left: 10px;vertical-align: middle">
                        </div>

                    </el-col>

                </el-row>
                <hr style="margin-left:40px;margin-right:20px;margin-top:10px;margin-bottom:12px;background-color: #DEDEDE"/>
            </div>
        </div>


        <el-row :gutter="24" :class="$style.row">
            <el-col :span="20"><span style="font-size: 12px;color: #B8B8B8">辅导评估</span></el-col>

            <el-col :span="4"><span style="float: right;font-size: 12px;color: #FF9901">平均分：{{average}}</span></el-col>
        </el-row>

        <div v-for="(item, index) in EvaluationOfTutoring">
            <div @click.stop="clickTutoring(item,index)" style="cursor:pointer">
                <el-row :gutter="24" :class="$style.row_child">
                    <el-col :span="12"><span style="font-size: 14px;color: #4D4D4D">{{item.clerk_name}}</span></el-col>

                    <el-col :span="12">
                        <div style="float: right;font-size: 14px">
                            <!--<span style="color: #86909A">未检查</span>-->
                            <!--<span :class="$style.span_round" style="background: #86909A">0</span>-->
                            <!--<span style="color: #6BC235">已合格</span>-->
                            <!--<span :class="$style.span_round" style="background: #6BC235">0</span>-->
                            <!--<span style="color: #D0011B">不合格</span>-->
                            <!--<span :class="$style.span_round" style="background: #D0011B">0</span>-->
                            <!--<span style="color: #B0B5B9;margin-right: 5px;margin-left: 5px">|</span>-->
                            <!--<span>20分</span>-->
                            <span>{{item.score}}分</span>

                            <img :src="arrow" height="12px" style="margin-left: 10px;vertical-align: middle">
                        </div>

                    </el-col>

                </el-row>
                <hr style="margin-left:40px;margin-right:20px;margin-top:10px;margin-bottom:10px;background-color: #DEDEDE"/>
            </div>
        </div>


        <el-row :gutter="24" :class="$style.row">
            <el-col :span="20"><span style="font-size: 12px;color: #B8B8B8">交接事项</span></el-col>

            <el-col :span="4"></el-col>
        </el-row>

        <div v-for="(item, index) in handOverMatters">
            <el-row :gutter="24" :class="$style.row_child">
                <el-col :span="12">
                    <span style="font-size: 14px;color: #4D4D4D">{{item.value1}}-{{item.value2}}</span>
                    <el-col>
                        <div v-for="(info, index) in item.info">
                            <span :class="$style.span_c">{{info.value1}}-{{info.value2}}</span>
                        </div>

                    </el-col>
                </el-col>

                <el-col :span="12"
                        style="position: absolute;top:50%;left:50%;width:100%;transform:translate(-50%,-50%)">
                    <div style="float: right;font-size: 14px;padding-right: 40px">
                        <span v-if="item.completed === 'T'" style="color: #86909A;vertical-align: middle">已完成</span>
                        <span v-else style="color: #6BC235">未完成</span>
                    </div>

                </el-col>

            </el-row>
            <hr style="margin-left:40px;margin-right:20px;margin-top:10px;margin-bottom:10px;background-color: #DEDEDE"/>
        </div>


    </div>
</template>
<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'

    import Arrow from '../../../assets/images/arrow_icon.png'
    import ImgUrl from '../../../assets/images/seal.png'

    export default {
        data() {
            return {
                loading: false,
                tags: ['巡店', '巡店详情'],
                title: '门店',
                subTitle: '基本信息',
                imgUrl: ImgUrl,
                arrow: Arrow,

                inspection_id: '',
                store_id: '',
                last_name: '',
                time: '',
                templateName: '',
                seal: false,

                zoom: 8,
                center: [116.46, 39.92],
                texts: [
                ],
                markers: [
                ],
                plugin: [{
                    pName: 'Scale',
                    events: {
                        init(instance) {

                        }
                    }
                }],

                checkAll: 0,
                average: 0,
                checkArray: [],
                EvaluationOfTutoring: [],
                handOverMatters: []
            }
        },
        components: {
            navBar
        },
        computed: {},
        created() {

            let obj = this.$store.getters.getInspection
            this.title = obj.storeName
            this.last_name = obj.last_name
            this.inspection_id = obj.id
            this.store_id = obj.store_id


            //查询门店经纬度和签到信息
            this.getLocationData()

            this.newGetInspectionInfo()


        },
        methods: {
            async newGetInspectionInfo() {
                this.loading = true
                try {


                    let data = {
                        user_id: this.$store.getters.getUser.user_id,
                        inspection_id: this.inspection_id,
                        store_id: this.store_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    // var url = this.Shop + '/newGetInspectionInfo'
                    // await this.$axios.post(url,data).then(res => {
                    //     this.time = res.data.start_date + ' 至 ' + res.data.end_date
                    //     this.loading = false
                    // })

                    await http.post('/wapi/v1/getInspectionInfo', data).then(res => {

                        let vm = this

                        this.time = res.data.start_date + ' 至 ' + res.data.end_date
                        this.templateName = res.data.item_title
                        if (res.data.completed === 'T') {
                            this.seal = true
                        } else {
                            this.seal = false
                        }
                        //检查事项
                        this.checkArray = res.data.CheckItems

                        this.checkArray.forEach(item => {

                            let pass = 0
                            let not_pass = 0
                            let allScore = 0
                            item.info.forEach(info => {

                                switch (info.type) {
                                    case 'STAR':
                                        allScore = allScore + parseInt(info.stars)
                                        if(info.option_id){
                                            if (parseInt(info.stars) >= parseInt(info.conformity) && info.stars !== '0') {
                                                pass += 1
                                            } else if (info.stars !== '0') {
                                                not_pass += 1
                                            }
                                        }

                                        break
                                    case 'SCORE':

                                        allScore = allScore + parseInt(info.score)
                                        if(info.option_id){
                                            if (parseInt(info.score) >= parseInt(info.conformity) && info.score !== '0') {
                                                pass += 1
                                            } else if (info.score !== '0') {
                                                not_pass += 1
                                            }
                                        }

                                        break
                                    case 'OPTION':

                                        let optionScore = 0
                                        for (let option of info.optionInfo) {
                                            optionScore = optionScore + parseInt(option.score)
                                        }

                                        if(info.option_id){
                                            if (optionScore >= parseInt(info.conformity)) {
                                                pass += 1
                                            } else {
                                                not_pass += 1
                                            }
                                        }

                                        allScore = allScore + optionScore
                                        break
                                    case 'TRUE-FALSE':

                                        // if(info.option_id){
                                            if (info.passed === 'PASSED') {
                                                allScore = allScore + parseInt(info.conformity)
                                                pass += 1
                                            } else if (info.passed === 'DENIED') {
                                                not_pass += 1
                                            }
                                        // }

                                        break
                                }

                            })
                            let unchecked = item.count - pass - not_pass
                            item.score = allScore.toFixed(1)
                            item.pass = pass
                            item.not_pass = not_pass
                            item.unchecked = unchecked


                            this.checkAll = this.checkAll + allScore

                        })


                        //辅导评估
                        this.EvaluationOfTutoring = res.data.EvaluationOfTutoring

                        this.EvaluationOfTutoring.forEach(item => {
                            let score = 0
                            item.info.forEach(info => {

                                switch (info.type) {
                                    case 'STAR':
                                        score = score + parseInt(info.stars)
                                        break
                                    case 'SCORE':
                                        score = score + parseInt(info.score)
                                        break
                                    case 'OPTION':

                                        if (info.optionInfo.length > 0) {
                                            let optionScore = 0
                                            for (let option of info.optionInfo) {
                                                optionScore = optionScore + parseInt(option.score)
                                            }

                                            score = score + optionScore
                                        }

                                        break
                                    case 'TRUE-FALSE':
                                        if (info.passed === 'PASSED') {
                                            score = score + parseInt(info.conformity)
                                        }
                                        break
                                }

                            })
                            item.score = score.toFixed(1)

                            this.average = this.average + score

                        })
                        if (this.EvaluationOfTutoring.length === 0) {
                            this.average = 0
                        } else {
                            this.average = (this.average / this.EvaluationOfTutoring.length).toFixed(1)
                        }

                        //签到信息

                        var text=''
                        var position=[]
                        if(res.data.checkIn.length > 0){

                            res.data.checkIn.forEach(item => {

                                vm.markers.push({
                                    position:[item.checkin_lng,item.checkin_lat],
                                    visible: true
                                })

                                text = text + "<span style='font-size: 10px;margin: 5px;color: #F5A623'>签入:" + item.checkin_time.substring(11,16) + "</span>"

                                if(item.checkout_time){
                                    text = text + "<span style='font-size: 10px;margin: 5px;color: #F5A623'>签出:" + item.checkout_time.substring(11,16) + "</span>" + "<br/>"
                                }else {
                                    text = text + "<span style='font-size: 10px;margin: 5px;color: #ED3B3F'>尚未签出</span>" + "<br/>"
                                }


                                position = [item.checkin_lng,item.checkin_lat]
                            })

                            vm.texts.push({
                                position:position,
                                name:text,
                                offset: [85, -20]
                            })

                        }
                        //交接事项
                        this.handOverMatters = res.data.handOverMatters


                        this.$store.commit('setInspection', {
                            checkArray: this.checkArray,
                            EvaluationOfTutoring: this.EvaluationOfTutoring
                        })

                        this.$store.commit('setInspection', {
                            id: this.inspection_id,
                            storeName: this.title,
                            store_id: this.store_id,
                            last_name: this.last_name,

                            checkArray: this.checkArray,
                            EvaluationOfTutoring: this.EvaluationOfTutoring
                        })

                        this.loading = false
                    })

                } catch (err) {
                    this.loading = true
                    console.log(`error:${err}`)
                }
            },
            async getLocationData() {

                try {

                    let data = {
                        username: this.$store.getters.getUser.username,
                        user_id: this.$store.getters.getUser.user_id,
                        inspection_id: this.inspection_id,
                        store_id: this.store_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    await http.post('/wapi/v1/getLocationData', data).then(res => {

                        let result = res.data

                        this.zoom = 14
                        this.center = [
                            parseFloat(result.lng), parseFloat(result.lat)
                        ]
                        // this.markers[0].position = [parseFloat(result.lng), parseFloat(result.lat)]
                        this.markers.push({
                            position:[parseFloat(result.lng), parseFloat(result.lat)],
                            visible: true
                        })
                    })

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            initMap() {
                // this.zoom = 14
                // this.center = [
                //     116.46, 39.92
                // ]
                // this.markers[0].position = [116.46, 39.92]
            },
            clickItems(item, index) {//检查事项点击跳转
                this.$router.push({
                    path: '/cruiseShop/checkItems',
                    query: {
                        index: String(index)
                    }
                })
            },
            clickTutoring(item, index) {//检查事项点击跳转
                this.$router.push({
                    path: '/cruiseShop/assessment',
                    query: {
                        index: String(index)
                    }
                })
            },
            // 返回按钮
            handleBackClick() {
                this.$router.push({
                    path: '/cruiseShop'
                })
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;

        .left {
            margin-left: 20px;
            margin-top: 20px;
            span {
                &:nth-child(1) {
                    display: inline-block;
                    margin-right: 60px;
                    color: #000000;
                    font-size: 16px;
                }
                &:nth-child(2) {
                    color: #4A90E2;
                    font-size: 16px;
                }
            }
        }
        .item {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            margin: 20px 0px;
            ul {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-items: center;
                li {
                    margin-left: 30px;
                    font-size: $fontSize;
                    color: #4a90e2;
                    text-align: left;
                }
            }
            .map {
                width: 100%;
                height: 180px;
                margin: 0px 20px;
            }
        }
        .row {
            padding-left: 20px;
            padding-right: 20px;
            margin-bottom: 15px;
            margin-top: 20px;
        }
        .row_child {
            margin-top: 5px;
            padding-left: 40px;
            padding-right: 30px;

            .span_round {
                font-size: 12px;
                color: #FFFFFF;
                border-radius: 15px;
                padding: 1px;
                display: -moz-inline-box;
                display: inline-block;
                text-align: center;
                line-height: 15px;
                min-width: 15px;
            }
            .span_c {
                font-size: 12px;
                color: #86909A;
                margin-left: -10px;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/cruiseShop/basicInfo/index.vue